import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import { getASNLog } from "services/data.inbound.service";
import Drawer from "ui-components/Drawer";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Qty Expected", id: "qtyExpected" },
];

function ASNLog({ open, setOpen, logRequest, setLogRequest, setAlert }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["asn-log", { logRequest }],
    queryFn: () => getASNLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>ASN Number : </b>
                {item.asnNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Date Expected : </b>
                {item.dateExpected}
              </Grid>
              <Grid item xs={6}>
                <b>PO Number : </b>
                {item.poNumber}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
      //setLogRequest({ asnNumber: "", customerCode: "" });
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <>
      <Drawer open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
        {logs}
      </Drawer>
    </>
  );
}

export default ASNLog;
